import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import useForm from 'assets/components/form/hooks/Form';
import FileInputSimple from 'assets/components/inputs/file/FileInputSimple';
import TextInput from 'assets/components/inputs/text/TextInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import { getLocales } from 'assets/locales/Locale';
import { useMemo } from 'react';

export default function ClaimDocumentForm(props: { onSubmit: (docs: Utils.FormData<Model.IClaimDocument>) => void }) {
  const { lang } = getLocales();

  const docForm = useForm<Utils.FormData<Model.IClaimDocument>>({
    default: {},
    onSubmit: async (data) => {
      props.onSubmit(data);
      docForm.reload();
    },
    validation: (data, errors) => {
      if (!data.name) errors.name = lang.required;
    },
  });
  const uploadedFile = useMemo(
    () =>
      !docForm.data?.formFile
        ? null
        : {
            original: docForm.data.formFile,
            type: docForm.data.formFile.type as Utils.File.MimeType,
            dataUrl: window.URL.createObjectURL(docForm.data.formFile),
            name: docForm.data.name,
            notes: docForm.data.notes,
          },
    [docForm.data.formFile]
  );

  return (
    <InputWrapper>
      <FileInputSimple
        name="file"
        value={uploadedFile}
        onChange={({ file }) => {
          docForm.update({
            formFile: file.original,
            name: file.original?.name,
          });
        }}
        label={lang.documentUpload}
      />
      <TextInput
        name="name"
        label={lang.name}
        value={docForm.data?.name}
        error={docForm.errors?.name}
        onChange={docForm.update}
        disabled={!uploadedFile}
      />
      <TextInput
        name="notes"
        label={lang.notes}
        value={docForm.data?.notes}
        onChange={docForm.update}
        disabled={!uploadedFile}
      />
      <Button
        render={lang.add}
        onClick={docForm.submit}
        active={!docForm.hasErrors}
        class={ThemeButtonCircle}
        style={{ flexShrink: 0 }}
        disabled={docForm.hasErrors || docForm.isSubmitted || !docForm.isUpdated || !docForm.data?.formFile}
      />
    </InputWrapper>
  );
}
